<template>
    <div class="container-availability-form">
        <section class="container-enterprises">
            <ui-select-v2
                v-model="form.data.product_id"
                :data="transformedProductOptions"
                :required="form.fields.product_id.required"
                :disabled="form.fields.product_id.disabled"
                label="Empreendimento Facilita:"
                item-label="name"
                return-value="id"
                design="br-default"
                size="sm"
                placeholder="Selecione um empreendimento"
                @input="productHandler"
                group-by="type"
            />

            <ui-select-v2
                v-model="form.data.integration_provider"
                :data="integrationProviderOptions"
                :required="form.fields.integration_provider.required"
                :disabled="form.fields.integration_provider.disabled"
                label="Empreendimento ERP:"
                item-label="name"
                design="br-default"
                size="sm"
                placeholder="Selecione um empreendimento"
                @input="$emit('input', form)"
            />
        </section>

        <a class="content-link" @click="createProduct">
            <div v-show="!id">Cadastrar</div>
        </a>

        <section class="container-enterprises">
            <ui-select-v2
                v-model="form.data.type"
                :data="typeOptions"
                :required="form.fields.type.required"
                :disabled="form.fields.type.disabled"
                return-value="value"
                label="Tipo de Disponibilidade:"
                design="br-default"
                size="sm"
                placeholder="Selecione um tipo"
                @input="typeHandler"
            />

            <ui-select-v2
                v-model="form.data.infos.showValue"
                :data="showValueOptions"
                :required="form.fields.showValue.required"
                :disabled="form.fields.showValue.disabled"
                return-value="value"
                label="Exibir valores Unidades:"
                design="br-default"
                size="sm"
                placeholder="Selecione uma opção"
                @input="$emit('input', form)"
            />
        </section>

        <div v-if="form.data.type === 'horizontal'" class="container-implantation">
            <div class="container-implantation-switch">
                <ui-switch
                    v-model="form.data.infos.hide_sales_mirror"
                    :checked="form.data.infos.hide_sales_mirror"
                    label="Ocultar Imagem de implatação"
                    design="xs primary"
                    required
                />

                <router-link to="/marketing/integracoes/erp/adicionar">
                    <div class="content-link-implantation">Visualizar Implantação</div>
                </router-link>
            </div>

            <!-- <ui-upload-logo label="Clique para enviar uma imagem:" /> -->
        </div>

        <div class="container-input-number">
            <div v-if="form.data.type === 'horizontal'" class="blocks-size-icon">
                <ui-input-number
                    v-model="form.data.infos.blocks"
                    :required="form.fields.blocks.required"
                    :disabled="form.fields.blocks.disabled"
                    :max-value="1000"
                    label="Quantidade de quadras:"
                    size="md"
                    @input="$emit('input', form)"
                />

                <ui-input-number
                    v-model="form.data.infos.sizeBall"
                    :required="form.fields.sizeBall.required"
                    :disabled="form.fields.sizeBall.disabled"
                    :max-value="100"
                    label="Tamanho ícone:"
                    size="md"
                />
            </div>

            <div v-else-if="form.data.type === 'vertical'">
                <div class="container-towers-floors">
                    <ui-input-number
                        v-model="form.data.infos.towers"
                        :required="form.fields.towers.required"
                        :disabled="form.fields.towers.disabled"
                        :max-value="1000"
                        label="Quantidade de torres:"
                        size="md"
                        @input="$emit('input', form)"
                    />

                    <ui-input-number
                        v-model="form.data.infos.floors"
                        :required="form.fields.floors.required"
                        :disabled="form.fields.floors.disabled"
                        :max-value="1000"
                        label="Quantidade de andares:"
                        size="md"
                        @input="$emit('input', form)"
                    />
                </div>

                <div class="container-towers-floors">
                    <ui-input-number
                        v-model="form.data.infos.underground"
                        :required="form.fields.underground.required"
                        :disabled="form.fields.underground.disabled"
                        :max-value="1000"
                        label="Quantidade de andares - Subsolo:"
                        size="md"
                        @input="$emit('input', form)"
                    />

                    <ui-input-number
                        v-model="form.data.infos.units"
                        :required="form.fields.units.required"
                        :disabled="form.fields.units.disabled"
                        :max-value="1000"
                        label="Quantidade de unidades:"
                        size="md"
                        @input="$emit('input', form)"
                    />
                </div>
            </div>
        </div>

        <div class="container-switch">
            <div v-if="form.data.type === 'horizontal'">
                <ui-switch
                    v-model="form.data.infos.hide_electronic_plant"
                    :checked="form.data.infos.hide_electronic_plant"
                    label="Ocultar espelho digital"
                    design="xs primary"
                    @input="$emit('input', form)"
                />
            </div>

            <div v-else-if="form.data.type === 'vertical'">
                <div class="container-switchs-floors">
                    <div class="floor-handler">
                        <ui-switch
                            v-model="form.data.infos.groundFloor"
                            :checked="form.data.infos.groundFloor"
                            label="Exibir térreo"
                            design="xs primary"
                            @input="$emit('input', form)"
                        />

                        <ui-switch
                            v-model="form.data.infos.show_unregister_floor"
                            :checked="form.data.infos.show_unregister_floor"
                            label="Ocultar andares altos"
                            design="xs primary"
                            @input="unregisterFloorHandler"
                        />
                    </div>

                    <div class="empty-hlander">
                        <ui-switch
                            v-model="form.data.infos.show_unregister_floor_empty"
                            :checked="form.data.infos.show_unregister_floor_empty"
                            :disabled="form.fields.show_unregister_floor_empty.disabled"
                            label="Ocultar andares vazios"
                            design="xs primary"
                            @input="unregisterFloorEmptyHandler"
                        />

                        <ui-switch
                            v-model="form.data.infos.show_unregister_units_empty"
                            :checked="form.data.infos.show_unregister_units_empty"
                            :disabled="form.fields.show_unregister_units_empty.disabled"
                            label="Ocultar unidades vazias"
                            design="xs primary"
                            @input="$emit('input', form)"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div v-show="loading">
            <ui-overlay-load />
        </div>
    </div>
</template>

<script>
	import { uiOverlayLoad } from '@/components/ui'
	import {
		uiSelectV2,
		uiSwitch,
		uiInputNumber
	} from '@/components/ui/form'
	// import { uiUploadLogo } from '@/components/ui/upload'

	import { erp, product } from '@/services/axios'

	import helpers from '@/mixins/helpers'

	export default {
		name: 'ui-integrations-erp-availability-form',

		components:{
			uiSelectV2,
			uiSwitch,
			// uiUploadLogo,
			uiInputNumber,
			uiOverlayLoad
		},

		mixins: [helpers],

		props: {
			value: {
				type: Object,
				required: true
			},
			integration: {
				type: Object,
				required: true
			},
			id: {
				type: [String,Number],
				required: false,
				default: null
			}
		},

		data() {
			return {
				loading: false,
				form: { ...this.value },
				productOptions: [],
				integrationProviderOptions: [],
				typeOptions: [
					{
						value: 'vertical',
						label: 'Vertical',
					},
					{
						value: 'horizontal',
						label: 'Horizontal',
					}
				],
				showValueOptions: [
					{
						label: 'Ocultar valor',
						value: 'hidden'
					},
					{
						label: 'Em unidades disponíveis',
						value: 'available'
					},
					{
						label: 'Em todas as unidades',
						value: 'all'
					}
				],
			}
		},

        computed: {
            transformedProductOptions() {
                return this.productOptions.map(item => {
                    return {
                        ...item,
                        type: item.availability_id !== null ? "Integrados" : "Não Integrado"
                    };
                });
            }
        },

		mounted() {
			this.loadForm()
            if(this.form.data.infos.show_unregister_floor){
                this.form.fields.show_unregister_floor_empty.disabled = false 
                if(this.form.data.infos.show_unregister_floor_empty){
                    this.form.fields.show_unregister_units_empty.disabled = false
                }
            }

			this.isEditDisabledIfIntegrated()
		},

		methods: {
			/**
			 * Carrega os dados necessários para montar o formulário
			 */
			loadForm: async function () {
				this.loading = true
				try {
					if (!this.integration) throw Error('Nenhuma integração foi selecionada!')

					let response = await erp.getAllV2(`${this.integration.id}/products`, {})
					if (response.data.data) this.integrationProviderOptions = [...response.data.data]

					response = await product.getAllV2('without/units', {})
					this.productOptions = [...response.data.data]

					/** Verifica se já existe um tipo de disponbilidade selecionado */
					if (this.form.data.type) this.typeHandler(this.form.data.type)

				} catch (error) {
					if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					else this.$toastr.e(error)

				} finally {
					this.loading = false
				}
			},
			/**
			 * Caso seja uma disponibilidade já cadastrada, desabilitado a edição
			 */
			isEditDisabledIfIntegrated(){
				if(!this.id) return

				this.form.fields.product_id.disabled = true
				this.form.fields.integration_provider.disabled = true
				this.form.fields.type.disabled = true
			},
			/**
			 * Handler function que trata o evento de mostrar os dados da implantação
			 */
			showImplantationHandler() {
				console.log('show')
			},
			/**
			 * Handler function que trata o evento de quando o tipo da disponibilidade
			 * é definido
			 */
			typeHandler(value) {
				if (!value) return

				/**
				 * Define os campos required caso estes sejam utilizados pelos empreendimentos
				 * horizontais ou verticais
				 */
				const isHorizontal = value === 'horizontal'
				this.form.fields.blocks.required = isHorizontal
				this.form.fields.towers.required = !isHorizontal
				this.form.fields.floors.required = !isHorizontal
				this.form.fields.units.required = !isHorizontal
				switch (value) {
					case 'horizontal':
						this.form.data.infos.towers = null
						this.form.data.infos.floors = null
						this.form.data.infos.units = null
						this.form.data.infos.underground = null
						this.form.data.infos.groundFloor = false
						this.form.data.infos.show_unregister_floor = false
						this.form.data.infos.show_unregister_floor_empty = false
						this.form.data.infos.show_unregister_units_empty = false
						break

					case 'vertical':
						this.form.data.infos.blocks = null
						this.form.data.infos.hide_electronic_plant = false
						break
				}
				this.$emit('input', this.form)
			},
			/**
			 * Handler function que trata o evento do switch que define se os andares
			 * altos serão mostrados
			 */
			unregisterFloorHandler(value) {
				if (!value) {
					this.form.data.infos.show_unregister_floor_empty = false
					this.form.data.infos.show_unregister_units_empty = false
				}
				this.form.fields.show_unregister_floor_empty.disabled = !value  
                if( !this.form.fields.show_unregister_units_empty.disabled ) this.form.fields.show_unregister_units_empty.disabled = true
				this.$emit('input', this.form)
			},
			/**
			 * Handler function que trata o evento do switch que define se os andares
			 * vazios serão mostrados
			 */
			unregisterFloorEmptyHandler(value) {
				if (!value) this.form.data.infos.show_unregister_units_empty = false
				this.form.fields.show_unregister_units_empty.disabled = !value
				this.$emit('input', this.form)
			},
			/**
			 * Handler function que trata o evento de quando um produto é selecionado para
			 * setar o dado da disponibilidade deste e carregar os mapeamentos dos campos
			 * das unidades
			 */
			productHandler(value) {
				if (!value) return
				const product = this.productOptions.find(option => option.id === value)
				if (product) this.form.data.id = product.availability_id
				this.$emit('input', this.form)
				this.$emit('reload')
			},
			/**
			 * Seta os dados necessários para o cadastro de um produto novo e muda para a tela
			 * do painel Legado na Etapa 1
			 */
			createProduct() {
				document.cookie = `product_integration_id=${this.integration.id}; path=/`
				this.$mx_oldPanelLinkButton('empreendimentos/etapa1')
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
